<template>
    <transition name="slide">
        <div class="bg-surface-secondary w-100">
            <header class="bg-surface-primary border-bottom">
                <div class="container-fluid py-4">
                    <div class="row align-items-center">
                        <div class="col">
                            <div class="d-flex align-items-center gap-4">
                                <div>
                                    <button type="button" class="btn-close text-xs" @click="$router.go(-1)"></button>
                                </div>
                                <div class="vr opacity-20 my-1"></div>
                                <h1 class="h4 ls-tight">Crear nueva unidad</h1>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="hstack gap-2 justify-content-end">
                                <button @click="CREATE()" type="button" class="btn btn-h btn-success px-3">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Guardar</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <main class="py-6 bg-surface-secondary">
                <div class="container-fluid max-w-screen-md vstack gap-3">
                    <div>
                        <small class="input-title">Imagen</small>
                        <v-file-input
                            small-chips
                            accept="image/*"
                            hide-details
                            truncate-length="50"
                                v-model="data.file"
                            :class="errors.file ? 'is-invalid' : ''"
                            class="form-control form-control-sm"
                            :placeholder="'Seleccionar Imagen'">
                        </v-file-input>
                        <small class="invalid-feedback" v-for="(error, index) in errors.file" :key="index">{{ error }}</small>
                    </div>
                    <div>
                        <small class="input-title">Nombre</small>
                        <input type="text" class="form-control form-control-sm" v-model="data.name" :class="errors.name ? 'is-invalid' : ''">
                        <small class="invalid-feedback" v-for="(error, index) in errors.name" :key="index">{{ error }}</small>
                    </div>
                    <div>
                        <small class="input-title">Placa</small>
                        <input type="text" class="form-control form-control-sm" v-model="data.plaque" :class="errors.plaque ? 'is-invalid' : ''">
                        <small class="invalid-feedback" v-for="(error, index) in errors.plaque" :key="index">{{ error }}</small>
                    </div>
                    <div>
                        <small class="input-title">Año</small>
                        <input type="text" class="form-control form-control-sm" @keypress="NUMBER" v-model="data.year" :class="errors.year ? 'is-invalid' : ''">
                        <small class="invalid-feedback" v-for="(error, index) in errors.year" :key="index">{{ error }}</small>
                    </div>
                    <div>
                        <small class="input-title">Marca</small>
                        <input type="text" class="form-control form-control-sm" v-model="data.maker" :class="errors.maker ? 'is-invalid' : ''">
                        <small class="invalid-feedback" v-for="(error, index) in errors.maker" :key="index">{{ error }}</small>
                    </div>
                    <div>
                        <small class="input-title">Modelo</small>
                        <input type="text" class="form-control form-control-sm" v-model="data.model" :class="errors.model ? 'is-invalid' : ''">
                        <small class="invalid-feedback" v-for="(error, index) in errors.model" :key="index">{{ error }}</small>
                    </div>
                </div>
            </main>
        </div>
    </transition>
</template>
<script>
export default{
    data(){
        return{
            data: {},
            errors: {},
            count: 0
        }
    },
    methods:{
        CREATE: function(){
            let vue = this
            vue.count++
            if(vue.count == 1){
                vue.errors = {}
                setTimeout(() => {
                    axios({url: '/units', method: 'POST', data: vue.data })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.$router.push({ name: 'UnitIndex' })
                    })
                    .catch((err) => {
                        if(err.response.status !== 422){
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.errors = err.response.data
                        }
                    })
                    .finally((resp)=>{
                        vue.count = 0
                    })
                }, 1000)
            }
        }
    }
}
</script>